import { render } from "./reception_appointments.vue?vue&type=template&id=3468d6d1"
import script from "./reception_appointments.vue?vue&type=script&lang=js"
export * from "./reception_appointments.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__